import { Component, inject } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'

@Component({
    selector: 'modal-content',
    templateUrl: './mediapopup.component.html',
    standalone: false
})
export class MediaPopupComponent {
    bsModalRef = inject(BsModalRef);

    isVideo: boolean
    source: any
    imageAlt: string
}
